<template>
  <v-card outlined class="pa-5 mb-5">
    <p>{{ name }}</p>
    <div v-for="el in items">
      <v-checkbox
        v-model="localData"
        :label="el.name"
        :value="el.id"
        :readonly="readonly"
        :disabled="disabled"
      ></v-checkbox>
    </div>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'CheckboxGroup',

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: Array,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localData: null
  }),

  computed: {},

  watch: {
    localData: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.localData)) {
          return;
        }
        this.setData();
      }
    }
  },

  created() {
    this.localData = [];
  },

  methods: {
    setData() {
      this.localData = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', Object.assign([], this.localData));
    }
  }
};
</script>
